export default {
  endpoints: {
    analyticsWebOverview: '/analytics/web/overview',
    analyticsWebTopPages: '/analytics/web/top-pages',
    analyticsWebSources: '/analytics/web/sources',
    analyticsWebDevices: '/analytics/web/devices',
    analyticsWebCountries: '/analytics/web/countries',
    analyticsWebDisplayMode: '/analytics/web/display-mode',
    analyticsWebRealtime: '/analytics/web/realtime',
    analyticsEmailOverview: '/analytics/email/overview',
    analyticsEmailCategories: '/analytics/email/categories',
    analyticsEmailCampaigns: '/analytics/email/campaigns',
    analyticsEmailSubscribers: '/analytics/email/subscribers',
    analyticsEmailSingleSends: '/analytics/email/single-sends',
    analyticsEmailToday: '/analytics/email/today',
    pageLayout: '/pages/layout',
    schedulerStatus: '/pages/scheduler-status',
    pages: '/pages',
    pageVersions: '/pages/versions',
    pageScheduler: '/pages', // Usage: pageScheduler + '/:id/scheduler'
    pageVersion: '/pages', // Usage: pageVersion + '/:id/version'
    competitions: '/competitions',
    leagueTable: '/competitions/league-table',
    leagueTables: '/competitions/league-tables',
    leagueTableSeasons: '/competitions/league-tables/seasons',
    leagueOptions: '/competitions/league-options',
    leagueCompetitions: '/competitions/leagues',
    divisionOptions: '/competitions/divisions',
    divisionsWithClubs: '/competitions/divisions/clubs',
    competitionsAdmin: '/competitions/admin',
    match: '/matches',
    matchMedia: '/matches', // Usage: matchMedia + '/:id/media'
    matches: '/matches',
    matchBulkParse: '/matches/bulk-parse',
    matchBulkCreate: '/matches/bulk-create',
    matchBulkTemplate: '/matches/bulk-template',
    matchesDashboardPostponed: '/matches/dashboard/postponed',
    matchesSeasons: '/matches/seasons',
    matchesTodayCompetitions: '/matches/today/competitions',
    articles: '/articles',
    faqs: '/faqs',
    // SC-894 Important Dates. `events` is the public expanded-occurrence read; the three
    // bulk paths mirror the matches import.
    events: '/events',
    eventsBulkTemplate: '/events/bulk-template',
    eventsBulkParse: '/events/bulk-parse',
    eventsBulkCreate: '/events/bulk-create',
    tags: '/tags',
    featuredTags: '/tags/featured',
    tagSuggestions: '/tags/suggestions',
    clubs: '/clubs',
    editableClubs: '/clubs/list-editable',
    clubsDashboardPendingDrafts: '/clubs/drafts/pending',
    clubStaffExport: '/clubs/staff-export',
    teams: '/teams',
    teamsByEditableClubs: '/teams/by-editable-clubs',
    teamsAllDefault: '/teams/all',
    assets: '/assets',
    upload: '/assets/upload',
    login: '/auth/login',
    switchTenant: '/auth/switch-tenant',
    myProfile: '/users/me',
    users: '/users',
    sponsors: '/sponsors',
    navigations: '/navigations',
    // PATCH-only — no GET route exists. Reads go through `navigations` (GET /navigations),
    // which already resolves footerComponents server-side. See navigations.controller.ts.
    navigationsFooterComponents: '/navigations/footer-components',
    newsletterSubscribe: '/mails/newsletter-subscribe',
    newsletterConfirm: '/mails/newsletter-confirm',
    jobs: '/jobs',
    socialNetworks: '/social-networks',
    pinnedItems: '/pinned-items',
    pinnedItemsReorder: '/pinned-items/reorder',
    contacts: '/contacts',
    fixtures: '/fixtures',
    settings: '/settings',
    matchSettings: '/settings/match',
    articleSettings: '/settings/article',
    themeSettings: '/settings/theme',
    resetTheme: '/settings/theme/reset',
    matchFilters: '/settings/match-filters',
    contactDetailsSettings: '/settings/contact-details',
    contactFormSubjectsSettings: '/settings/contact-form-subjects',
    manageContactFormSubjectsSettings: '/settings/contact-form-subjects/manage',
    divisionsOrder: '/settings/divisions-order',
    releaseNotes: '/release-notes',
    releaseNotesLatest: '/release-notes/latest',
    videos: '/videos',
    videosPublished: '/videos/published',
    videoChannels: '/video-channels',
    footballPlayers: '/football-players',
    footballPlayersAutocomplete: '/football-players/autocomplete',
    footballPlayersStatsQuery: '/football-players/stats-query',
    footballPlayersReconcile: '/football-players/reconcile',
    attendanceStats: '/matches/stats/attendance',
    clubAttendanceList: '/matches/stats/attendance/by-club',
    matchSummary: '/matches/stats/match-summary',
    teamRankings: '/matches/stats/team-rankings',
    goalTiming: '/matches/stats/goal-timing',
    clubStats: '/matches/stats/club',
    historyLogs: '/history-logs',
    historyLogsEntityTypes: '/history-logs/entity-types',
    historyLogsUsers: '/history-logs/users',
    pageTemplates: '/page-templates',
    playerStatsPresets: '/player-stats-presets',
    tenants: '/tenants',
    tenantConfig: '/tenants/me',
    albums: '/albums',
    // Mirrored in packages/data/src/endpoints.ts — see the note there.
    engagementCampaigns: '/engagement/campaigns',
    engagementHistory: '/engagement/history',
    engagementHub: '/engagement/hub',
    engagementEntries: '/engagement/entries',
    engagementAdminCampaigns: '/engagement/admin/campaigns',
    matchSimulation: '/match-simulation',
    scheduledTasks: '/scheduled-tasks',
    files: '/files',
    filesRecentUploads: '/files/recent-uploads',
    fileAccessLogsRecent: '/file-access-logs/recent',
    leagueTableDiscrepancies: '/league-table-discrepancies',
    folders: '/folders',
    fileManager: '/file-manager',
    fileManagerContents: '/file-manager/contents',
    fileManagerInfo: '/file-manager/info',
    fileManagerSearch: '/file-manager/search',
    fileManagerMove: '/file-manager/move',
    fileManagerCopy: '/file-manager/copy',
    fileManagerDelete: '/file-manager/delete',
    ppvVideosPublished: '/ppv-videos/published',
    ppvVideosCompetitions: '/ppv-videos/competitions',
    reports: '/reports',
    reportsGenerate: '/reports/generate',
    cacheFlush: '/cache/flush',
    tutorials: '/tutorials',
    // SuperAdmin authoring (SC-1119). `allowlists` is a sibling of the collection root, not an id —
    // the API declares it above `:id` for that reason.
    tutorialsManage: '/tutorials/manage',
    tutorialsManageAllowlists: '/tutorials/manage/allowlists',
    aiGenerateTutorial: '/ai/generate-tutorial',
    // Bug tracker (proxied through API to bugTracker service)
    bugTrackerEvents: '/bug-tracker/events',
    bugTrackerIssues: '/bug-tracker/issues',
    // Web Push goal alerts. Public routes, tenant-scoped via x-tenant-id.
    pushVapidPublicKey: '/push/vapid-public-key',
    pushSubscriptions: '/push/subscriptions',
    pushSubscriptionsRemove: '/push/subscriptions/remove',
  },
  competitionClubs: (competitionId: string) => `/competitions/${competitionId}/clubs`,
  /**
   * SC-1227 stage and group CRUD. Every path is keyed on the subdocument `_id`, never on a
   * position in `stages[]` or `groups[]`: reorder and archive both leave those ids alone, and
   * `Match.stage`, `Match.group` and `LeagueTable.group` all reference them, with no `populate`
   * able to surface a dangling one.
   *
   * `reorder` sits above `byId` on purpose. `/stages/reorder` is otherwise matched by the
   * `:stageId` param route, so the controller must declare the literal first — the same ordering
   * rule the controller's own comment convention already applies to `GET` sub-resources.
   *
   * `group`'s DELETE is an **archive**, not a removal: SC-1227 soft-deletes a group so that the
   * fixtures and league-table row naming it keep resolving. The path is the REST-conventional one
   * because the editor's intent is "delete this group"; what the server does with it is the
   * server's contract, documented on the hook.
   */
  competitionStages: {
    create: (competitionId: string) => `/competitions/${competitionId}/stages`,
    reorder: (competitionId: string) => `/competitions/${competitionId}/stages/reorder`,
    byId: (competitionId: string, stageId: string) => `/competitions/${competitionId}/stages/${stageId}`,
    groups: (competitionId: string, stageId: string) => `/competitions/${competitionId}/stages/${stageId}/groups`,
    group: (competitionId: string, stageId: string, groupId: string) =>
      `/competitions/${competitionId}/stages/${stageId}/groups/${groupId}`,
    groupTeams: (competitionId: string, stageId: string, groupId: string) =>
      `/competitions/${competitionId}/stages/${stageId}/groups/${groupId}/teams`,
    /**
     * Un-archive a group — the exact inverse of `group`'s DELETE, restoring its `_id`, its name and
     * its teams. It exists because the delete is a soft one: without a way back, "archive" would be
     * a deletion with extra storage rather than a reversible action, and the teams it removed from
     * the competition's membership (and therefore from its division-folder grants) would stay
     * removed with no way to put them back except retyping the group.
     */
    groupRestore: (competitionId: string, stageId: string, groupId: string) =>
      `/competitions/${competitionId}/stages/${stageId}/groups/${groupId}/restore`,
  },
  clubExport: (id: string) => `/clubs/${id}/export`,
  seasonConfigs: {
    list: (competitionId: string) => `/competitions/${competitionId}/seasons`,
    create: (competitionId: string) => `/competitions/${competitionId}/seasons`,
    current: (competitionId: string) => `/competitions/${competitionId}/seasons/current`,
    byId: (competitionId: string, seasonId: string) => `/competitions/${competitionId}/seasons/${seasonId}`,
    update: (competitionId: string, seasonId: string) => `/competitions/${competitionId}/seasons/${seasonId}`,
    delete: (competitionId: string, seasonId: string) => `/competitions/${competitionId}/seasons/${seasonId}`,
    setCurrent: (competitionId: string, seasonId: string) =>
      `/competitions/${competitionId}/seasons/${seasonId}/set-current`,
    activate: (competitionId: string, seasonId: string) =>
      `/competitions/${competitionId}/seasons/${seasonId}/activate`,
  },
  matchChangesets: {
    submit: (matchId: string) => `/matches/${matchId}/changeset`,
    byMatch: (matchId: string) => `/matches/${matchId}/changeset`,
    pending: '/matches/changesets/pending',
    approve: (changesetId: string) => `/matches/changesets/${changesetId}/approve`,
    reject: (changesetId: string) => `/matches/changesets/${changesetId}/reject`,
    retract: (changesetId: string) => `/matches/changesets/${changesetId}`,
  },
  // The admin's manual "Pull from IFAS": POST pulls, GET lists the match's pulls (`?page=&limit=`), GET one reads it.
  matchIfasPulls: {
    pull: (matchId: string) => `/matches/${matchId}/ifas-pull`,
    list: (matchId: string) => `/matches/${matchId}/ifas-pulls`,
    byId: (matchId: string, pullId: string) => `/matches/${matchId}/ifas-pulls/${pullId}`,
  },
  // SC-894: single Important Date, for the admin edit dialog. The public list returns
  // expanded occurrences, so this is the only route that yields the source document with
  // its recurrence rule intact.
  event: (id: string) => `/events/${encodeURIComponent(id)}`,
  fileView: (id: string) => `/files/${id}/view`,
  fileViews: (id: string) => `/files/${id}/views`,
  folderGrants: (id: string) => `/folders/${id}/grants`,
  folderGrantClubs: (id: string) => `/folders/${id}/grants/clubs`,
  folderGrantClub: (id: string, clubId: string) => `/folders/${id}/grants/clubs/${clubId}`,
  folderGrantAllClubs: (id: string) => `/folders/${id}/grants/all-clubs`,
  folderGrantDivision: (id: string) => `/folders/${id}/grants/division`,
  // SC-942: PUT to set / DELETE to clear a Tag's polymorphic Club/Player association
  tagAssociation: (id: string) => `/tags/${id}/association`,
  feeds: {
    // SC-1142: public, unauthenticated fixtures .ics feed. Both path segments are
    // encodeURIComponent'd here — the single source of truth for every consumer (currently
    // buildCalendarTargets.ts) — since a tenantId/teamId containing characters that need escaping
    // would otherwise produce a broken path.
    teamFixtures: (tenantId: string, teamId: string) =>
      `/feeds/${encodeURIComponent(tenantId)}/teams/${encodeURIComponent(teamId)}/fixtures.ics`,
    // Single-fixture .ics for the Add to Calendar menu. Team-scoped so the shared ICS mapper
    // keeps its home/away perspective. Every segment is encodeURIComponent'd, as above.
    teamMatchIcs: (tenantId: string, teamId: string, matchId: string) =>
      `/feeds/${encodeURIComponent(tenantId)}/teams/${encodeURIComponent(teamId)}/matches/${encodeURIComponent(matchId)}.ics`,
    // SC-894: the Important Dates subscribe feed and the single-event download. Tenant lives
    // in the PATH rather than the x-tenant-id header for the same reason as the fixtures
    // feed above — a calendar client cannot send a custom header, so a header-routed .ics
    // would 400 at TenantsMiddleware for every subscriber.
    events: (tenantId: string) => `/feeds/${encodeURIComponent(tenantId)}/events.ics`,
    eventIcs: (tenantId: string, eventId: string) =>
      `/feeds/${encodeURIComponent(tenantId)}/events/${encodeURIComponent(eventId)}.ics`,
  },
};
